<tt-page class="col-xs-12 col-md-6 sp-0">
    <tt-list [ttData]="itemsListOffDutyCodes"></tt-list>

    <tt-card>
        <tt-button-goto [ttText]="'create_new_offdutycode'" (ttClick)="goToFunc('offdutycode')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>
</tt-page>
